<template>
   <div>
    <div>
      <table class="VueTables__table table is-bordered is-fullwidth is-striped">
        <thead>
        <th class="colonne-responsive">
          {{ $t('echeancierFacturation.tabsEcheancierLignes.payeur') }}
        </th>
        <th class="colonne-responsive">
          {{ $t('echeancierFacturation.tabsEcheancierLignes.montant') }}
        </th>
        <th class="colonne-responsive--date">
          {{ $t('echeancierFacturation.tabsEcheancierLignes.dateDebut')}}
        </th>
        <th class="colonne-responsive--date">
          {{ $t('echeancierFacturation.tabsEcheancierLignes.dateFin') }}
        </th>
        <th class="colonne-responsive--date">
          {{ $t('echeancierFacturation.tabsEcheancierLignes.aFacturer') }}
        </th>
        <th class="colonne-responsive--facturation">
          {{ $t(`echeancierFacturation.tabsEcheancierLignes.${getLibelleColonneFacture}`) }}
        </th>
        <th>
          {{ $t('echeancierFacturation.tabsEcheancierLignes.commentaire') }}
        </th>
        <th/>
        </thead>
        <tbody>
        <template v-for="payeur in getPayeurs">
        <tr v-for="(ligne, index) in getLignesWithTiersId(payeur.tiersId)"
            :key="ligne.id"
            :class="{'background-error-table' :
            checkErrorDate(index, getLignesWithTiersId(payeur.tiersId))}">
          <td class="pd-3px colonne-responsive">
            <b-select v-model="ligne.tiersId" expanded
                      :disabled="ligne.facturationFaite">
              <option v-for="payeur in payeurs"
                      :key="payeur.tiersId"
                      :value="payeur.tiersId">
                {{ payeur.nomCommercial }}
              </option>
            </b-select>
          </td>
          <td class="pd-3px colonne-responsive">
            <b-field>
              <input-currency v-model="ligne.montant"
                              isNumber="true"
                              :peutEtreNegatif="echeanceNegativeVenteEstAutorise"
                              size="default"
                              :disabled="ligne.facturationFaite">
              </input-currency>
            </b-field>
          </td>
          <td class="pd-3px colonne-responsive--date">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          v-model="ligne.dateDebut"
                          icon="calendar-today"
                          :editable='true'
                          :disabled="ligne.facturationFaite">
            </b-datepicker>
          </td>
          <td class="pd-3px colonne-responsive--date">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          v-model="ligne.dateFin"
                          :min-date="ligne.dateDebut"
                          icon="calendar-today"
                          :editable='true'
                          :disabled="ligne.facturationFaite">
            </b-datepicker>
          </td>
          <td class="pd-3px colonne-responsive--date">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          v-model="ligne.datePrevisionnelleFacturation"
                          icon="calendar-today"
                          :editable='true'
                          :disabled="ligne.facturationFaite">
            </b-datepicker>
          </td>
          <td class="colonne-responsive--facturation">
              <div class="columns" v-if="isCommande">
                <div class="column is-1">
                  <b-checkbox v-model="ligne.facturationFaite"
                    :disabled="hasRealBill(ligne)">
                  </b-checkbox>
                </div>
                <div class="column is-11">
                  <span v-if="ligne.facturationFaite && ligne.factureId">
                      {{ $t('echeancierFacturation.tabsEcheancierLignes.dateFacture',
                        { dateFacture: dateFacture(ligne) }) }}</span>
                  <span v-else-if="ligne.facturationFaite && !ligne.factureId">
                  {{ $t('echeancierFacturation.indicateurFacturation') }}</span>
                </div>
              </div>
            <div v-else>
              <span v-if="ligne.facture">{{ ligne.facture.dateDevisCommande | formatDate }}</span>
            </div>
          </td>
          <td class="has-text-centered">
            <b-tooltip position="is-left"
                       v-if="ligne.commentaireFacturation"
                       type="is-primary">
              <b-icon icon="information" type="is-primary">
              </b-icon>
              <template v-slot:content>
                <p class="ellipsis max-width-715">
                  {{ ligne.commentaireFacturation }}
                </p>
              </template>
            </b-tooltip>
          </td>
          <td>
            <div class="has-text-centered">
              <a
                :class="{ 'disabled': ligne.facturationFaite}"
                @click="deleteEcheancierLigne(ligne.id)">
                <b-icon
                  icon="delete-forever"
                  type="is-danger">
                </b-icon>
              </a>
            </div>
          </td>
          <td class="has-text-centered">
            <b-dropdown position="is-bottom-left" class="has-text-left"
                        aria-role="list">
              <a slot="trigger">
                <b-icon
                  custom-class="has-text-icon-more"
                  icon="dots-vertical">
                </b-icon>
              </a>
              <b-dropdown-item aria-role="listitem"
                               @click="editCommentaire(ligne)">
                <div class="media">
                  <div class="media-content">
                    <p class="is-default font-dropdown">
                      {{ $t('echeancierFacturation.actions.gestionCommentaireUnitaire') }}
                    </p>
                  </div>
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </td>
        </tr>
        <tr :key="payeur.tiersId" class="has-text-link"
            v-if="payeur.tiersId && payeurs.length > 1">
          <td class="has-text-weight-bold">
            {{ $t('echeancierFacturation.tabsEcheancierLignes.totalPayeur', {
            nomCommercial: payeur.nomCommercial, quotePart: payeur.quotePart}) }}
          </td>
          <td class="right">
            {{ getTotalEcheancier(getLignesWithTiersId(payeur.tiersId)) | formatDevise }}
            / {{ getMontantRepartition(payeur) | formatDevise }}
          </td>
          <td colspan="7"></td>
        </tr>
        </template>
        <tr class="has-text-weight-bold">
          <td>
            {{ $t('echeancierFacturation.tabsEcheancierLignes.total') }}
          </td>
          <td class="right">
            <div :class="{'has-text-danger' : isTotalDifferent && !hasIndexation}">
              {{ getTotalEcheancier(echeancierLignes) | formatDevise }}
              / {{ montantEcheances | formatDevise }}
            </div>
          </td>
          <td colspan="7">
            <div v-if="isTotalDifferent && !hasIndexation" class="has-text-danger">
              {{ $t('echeancierFacturation.messages.errors.totalDifferent') }}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
     <b-modal v-model="openPopUpEditCommentaire"
              has-modal-card
              class="modal">
       <pop-up-edit-commentaire-facturation :echeancier-lignes="[ligneEcheanceToUpdate]"
                                            @updateCommentaire="updateCommentaireFacturation">
       </pop-up-edit-commentaire-facturation>
     </b-modal>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { MONTANT } from '@/configuration/devisConf';
import inputCurrency from '@/components/general/inputCurrency';
import { checkUnconsecutiveDate } from '@/services/commande/echeancierFacturation/checkUnconsecutiveDateEcheanciers';
import popUpEditCommentaireFacturation
  from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/p_commentaireFacturation';
import messageSucces from '@/services/general/messageSucces';
import formatDate from '@/services/general/formatDate';
import autoriseEcheanceNegativeVente from '@/services/general/autoriseEcheanceNegativeVente';

export default {
  props: {
    echeancierLignes: {
      type: Array,
      required: true,
    },
    payeurs: {
      type: Array,
      required: true,
    },
    montantHtCommande: {
      type: Number,
      required: true,
    },
    montantEcheances: {
      type: Number,
      required: true,
    },
    showErrorDate: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      lastTotalLigneIsPair: false,
      ligneEcheanceToUpdate: [],
      openPopUpEditCommentaire: false,
      echeanceNegativeVenteEstAutorise: false,
    };
  },
  components: {
    inputCurrency,
    popUpEditCommentaireFacturation,
  },
  computed: {
    getPayeurs() {
      const payeurs = cloneDeep(this.payeurs);
      payeurs.push({ tiersId: null });
      return payeurs;
    },
    isTotalDifferent() {
      if (this.montantEcheances == null) return false;
      return (this.montantEcheances.toFixed(2)
        !== this.getTotalEcheancier(this.echeancierLignes)?.toFixed(2));
    },
    hasIndexation() {
      return this.echeancierLignes.some(ech => ech.indexation?.pourcentageReel !== null);
    },
    getLibelleColonneFacture() {
      if (this.isCommande()) return 'facturer';
      return 'facturerDevis';
    },
  },
  methods: {
    hasRealBill(ligne) {
      return ligne.factureId !== null && ligne.factureId !== undefined;
    },
    editCommentaire(ligne) {
      this.ligneEcheanceToUpdate = ligne;
      this.openPopUpEditCommentaire = true;
    },
    updateCommentaireFacturation(newCommentaire) {
      messageSucces(this.$i18n.t('echeancierFacturation.messages.success.editCommentaire'));
      this.openPopUpEditCommentaire = false;
      const ligneFind = this.echeancierLignes.find((ligne) => {
        return ligne.id === this.ligneEcheanceToUpdate.id;
      });
      if (ligneFind) ligneFind.commentaireFacturation = newCommentaire;
      this.ligneEcheanceToUpdate = null;
    },
    deleteEcheancierLigne(id) {
      if (this.echeancierLignes.length === 1) {
        this.$emit('prepareEcheancierSuppression');
      } else {
        const index = this.echeancierLignes.findIndex((ligne) => {
          return ligne.id === id;
        });
        this.echeancierLignes.splice(index, 1);
      }
    },
    checkErrorDate(indexLigne, lignes) {
      if (!this.showErrorDate || indexLigne === 0) return false;
      return checkUnconsecutiveDate(lignes[indexLigne].dateDebut, lignes[indexLigne - 1].dateFin);
    },
    getLignesWithTiersId(tiersId) {
      return this.echeancierLignes.filter((ligne) => { return ligne.tiersId === tiersId; });
    },
    getMontantRepartition(payeur) {
      let repartition = 0;
      if (payeur.typeRepartition === MONTANT) {
        repartition = (payeur.repartition * 100) / this.montantHtCommande;
      } else repartition = payeur.repartition;
      return (repartition * this.montantEcheances) / 100;
    },
    getTotalEcheancier(lignes) {
      const montantsLigne = lignes.map(ligne => ligne.montant);
      if (montantsLigne.length > 0) {
        return montantsLigne.reduce((montantTotal, montant) => montantTotal + montant);
      }
      return 0;
    },
    isCommande() {
      if (this.$route.name === 'm.bodac.commandes'
        || this.$route.name === 'm.bodac.commandes-ajout') {
        return true;
      }
      return false;
    },
    dateFacture(ligne) {
      if (ligne === null || ligne === undefined
        || ligne.facture === undefined || ligne.facture === null) return '';
      return formatDate(ligne.facture.dateDevisCommande);
    },
  },
  async mounted() {
    this.echeanceNegativeVenteEstAutorise = await autoriseEcheanceNegativeVente();
  },
};
</script>
